// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"6241d41f","453":"68693753","531":"f2f6f313","550":"a5cdf60e","967":"9ce86236"}[chunkId] + ".chunk.js";
};